<script>
  import { onMount, onDestroy } from 'svelte';
  import CPUMonitor from '../components/CPUMonitor.svelte';
  import MemoryMonitor from '../components/MemoryMonitor.svelte';
  import { getCPU, getMemory } from '../services/api';

  let cpuData = { system: { percent: 0, cores: 0, model: '' }, perApp: [] };
  let memData = { system: { percent: 0, usedGB: '0', totalGB: '0', freeGB: '0' }, perApp: [] };
  let loading = true;
  let interval;

  onMount(async () => {
    await refresh();
    interval = setInterval(refresh, 3000);
  });

  onDestroy(() => {
    if (interval) clearInterval(interval);
  });

  async function refresh() {
    try {
      const [cpu, mem] = await Promise.all([getCPU(), getMemory()]);
      if (cpu.success) cpuData = cpu;
      if (mem.success) memData = mem;
    } catch (err) {
      console.error('Resources refresh error:', err);
    } finally {
      loading = false;
    }
  }
</script>

<div class="resources-page">
  <h1 class="section-title">
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
      <rect x="4" y="4" width="16" height="16" rx="2"/><rect x="9" y="9" width="6" height="6"/>
      <line x1="9" y1="1" x2="9" y2="4"/><line x1="15" y1="1" x2="15" y2="4"/>
      <line x1="9" y1="20" x2="9" y2="23"/><line x1="15" y1="20" x2="15" y2="23"/>
    </svg>
    Resources
  </h1>

  {#if loading}
    <div class="loading-state">
      <div class="spinner"></div>
      <span>Loading resource data...</span>
    </div>
  {:else}
    <div class="resources-grid">
      <CPUMonitor
        percent={cpuData.system.percent}
        cores={cpuData.system.cores}
        model={cpuData.system.model}
        perApp={cpuData.perApp}
      />
      <MemoryMonitor
        percent={memData.system.percent}
        usedGB={memData.system.usedGB}
        totalGB={memData.system.totalGB}
        freeGB={memData.system.freeGB}
        perApp={memData.perApp}
      />
    </div>

    <div class="refresh-info">
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <polyline points="23 4 23 10 17 10"/><path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"/>
      </svg>
      Auto-refreshing every 3 seconds
    </div>
  {/if}
</div>

<style>
  .resources-page {
    animation: fadeIn 0.3s ease;
  }

  .loading-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 14px;
    padding: 60px;
    color: var(--text-secondary);
    font-size: 14px;
  }

  .spinner {
    width: 28px;
    height: 28px;
    border: 2px solid var(--border-default);
    border-top-color: var(--neon-blue);
    border-radius: 50%;
    animation: spinSlow 0.8s linear infinite;
  }

  .resources-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
  }

  .refresh-info {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    margin-top: 20px;
    font-size: 12px;
    color: var(--text-tertiary);
  }

  .refresh-info svg {
    animation: spinSlow 3s linear infinite;
    opacity: 0.5;
  }

  @media (max-width: 1024px) {
    .resources-grid { grid-template-columns: 1fr; }
  }
</style>
